<div class="jit-bottom-sidebar" [class.is-opened]="isOpened">
  <div class="jit-bottom-sidebar__content">
    <ng-content select="[content]"></ng-content>
  </div>
</div>
@if (showOverlay) {
  <div class="jit-bottom-sidebar__overlay" [class.is-opened]="isOpened"></div>
}